<template>
  <div class="main cursor-pointer h-100">
    <div
        @click.prevent.passive="toggleFileSelector"
        class="dropzone-container p-0 h-100"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
    >
      <input
          type="file"
          :id="id"
          class="d-none"
          @change="onChange"
          ref="fileInput"
          accept=".jpg,.jpeg,.png"
      />
      <div v-if="fileUrl" id="selected-files" class="position-relative h-100" :class="{ 'rounded-circle': circle }"
           :style="{ backgroundImage: 'url(' + fileUrl + ')', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', }">
        <div class="position-absolute top-0 end-0">
          <span v-if="false" @click.prevent.exact.self="toggleFileSelector" class="btn btn-sm btn-icon opacity-50 opacity-100-hover me-1"> <i class="fa fa-edit text-primary"></i> </span>
          <span v-if="false" @click.prevent.passive="removeFile" class="btn btn-sm btn-icon opacity-50 opacity-100-hover"> <i class="fa fa-times text-danger"></i> </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import Img from "@/components/Img.vue";

const props = defineProps({
  id: { type: String, required: true },
  size: { type: String, default: '5Mo' },
  file: Object,
  circle: { type: Boolean, default: false },
  edit: { type: Boolean, default: true },
});

const emit = defineEmits(['addFile', 'removeFile']);

const isDragging = ref(false);
const fileInput = ref(null);

const fileUrl = computed(() => {
  if (props.file instanceof File) {
    return props.file.name;
  } else {
    return props.file.url || props.file
  }
})

const toggleFileSelector = (e) => {
  fileInput.value.click();
};

const onChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  emit('addFile', selectedFiles[0]);
};

const dragover = (e) => {
  e.preventDefault();
  isDragging.value = true;
};

const dragleave = () => {
  isDragging.value = false;
};

const drop = (e) => {
  e.preventDefault();
  if (!fileInput.value) {
    fileInput.value = document.querySelector('#' + props.id);
  }
  const droppedFiles = Array.from(e.dataTransfer.files);
  fileInput.value.files = e.dataTransfer.files;
  emit('addFile', droppedFiles[0]);
  isDragging.value = false;
};

const displayFile = () => {
  if (props.file instanceof File) {
    return URL.createObjectURL(props.file);
  } else {
    return props.file.url || props.file
  }
};

const removeFile = () => {
  emit('removeFile');
};



</script>

<style scoped>
.dropzone-container {
  border-radius: 5px;
  padding: 10px;
  transition: background-color 0.3s;
}
.dropzone-container.dragging {
  background-color: #f0f0f0;
}
.min-h-50px {
  min-height: 50px;
}
.min-h-40px {
  min-height: 40px;
}
.bg-light-primary {
  background-color: #e7f5ff;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
